// Persistent per-device identifier for compliance/audit logging.
//
// Browsers expose no hardware id, so we generate a random UUID once and keep it
// in localStorage. It is sent as the `X-Device-Id` header on every API request
// (see services/api.js). Survives page reloads and revisits on the same browser.

const STORAGE_KEY = 'bmf_device_id';

function generateUuid() {
  // Prefer the native generator; fall back to a manual v4 for old browsers.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage unavailable (private mode / blocked) — fall back to a
    // per-session id so requests still carry something.
    return generateUuid();
  }
}
